<ng-snotify></ng-snotify>

<router-outlet></router-outlet>
